module.exports = __webpack_public_path__ + "img/22.0eea86a2.jpg";